import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type SecurityRiskAssessmentInfo = {
  id: number | null;
};

type SecurityRiskAssessmentStateType = {
  selectedEntitySecurityAssessmentInfo: SecurityRiskAssessmentInfo;
};

const INITIAL_SECURITY_RISK_ASSESSMENT_STATE: SecurityRiskAssessmentStateType =
  {
    selectedEntitySecurityAssessmentInfo: { id: null },
  };

const SecurityRiskAssessmentSlice = createSlice({
  name: 'security-risk-assessment',
  initialState: INITIAL_SECURITY_RISK_ASSESSMENT_STATE,
  reducers: {
    setSelectedEntitySecurityAssessmentInfo: (
      state,
      action: PayloadAction<SecurityRiskAssessmentInfo>
    ) => {
      state.selectedEntitySecurityAssessmentInfo.id = action.payload.id;
    },
  },
});

export const { setSelectedEntitySecurityAssessmentInfo } =
  SecurityRiskAssessmentSlice.actions;

export default SecurityRiskAssessmentSlice.reducer;
